import AccountCircle from '@mui/icons-material/AccountCircle'
import {Button, IconButton} from '@mui/material'
import {useTheme} from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import {memo} from 'react'
import {useTranslation} from 'react-i18next'
import {useEffectEvent} from '../../../hooks/useEffectEvent'
import {useLogged} from '../../../states/auth'
import {useSetLoginModal} from '../../../states/loginModal'
import {breakSizeMobile} from '../Dashboard'
import {UserSelectorSettings} from './UserSettings/UserSelectorSettings'

const UserSelectorLogin = memo(() => {
  const theme = useTheme()
  const compact = useMediaQuery(theme.breakpoints.down(breakSizeMobile))
  const setLoginModal = useSetLoginModal()
  const {t} = useTranslation()

  const handleClickOpen = useEffectEvent(() => {
    setLoginModal(true)
  })

  if (compact) {
    return <IconButton onClick={handleClickOpen} color="inherit">
      <AccountCircle/>
    </IconButton>
  }

  return <Button onClick={handleClickOpen} color="inherit" sx={{whiteSpace: 'nowrap', minWidth: 'fit-content'}}>
    {t('page.authentication.button')}
  </Button>
})

export const UserSelector = memo(() => {
  const logged = useLogged()
  if (logged === undefined) {
    return <UserSelectorSettings/>
  }

  if (!logged) {
    return <UserSelectorLogin/>
  }

  return <UserSelectorSettings/>
})
